module.exports = __webpack_public_path__ + "static/img/Chteau-de-Versailles.4aa3943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chteau-de-Versailles.jpg
// module id = GtlE
// module chunks = 0